import { string } from '~/prix'
import defineGeoSyncFetchAction from '../shared/geoSyncFetchDefinition'
import geoSyncFetchAction from './geoSyncFetch.action.json' with { type: 'json' }

const geoSyncFetchDefinition = defineGeoSyncFetchAction(geoSyncFetchAction, {
  entity: string(),
})

export default geoSyncFetchDefinition
